import { EmbedFrame } from "@/components/embed-frame";
import { FlowComponentHeader } from "@/components/ui/flow-component-header";
import { useT } from "@/lib/i18n/use-t";
import type { EmbedConfig } from "@/lib/types/flow";
import { T } from "./embed-renderer.i18n";

type EmbedRendererProps = {
  config: EmbedConfig;
};

export function EmbedRenderer({ config }: EmbedRendererProps) {
  const t = useT(T);
  // The stored config is untyped on the server: guard against a non-string.
  if (typeof config.html !== "string" || !config.html) {
    return (
      <div className="p-6 text-center">
        <p className="text-sm text-muted-foreground">{t.noContent}</p>
      </div>
    );
  }

  // Same style vocabulary as the data-driven widgets (see
  // client-preferences-widget): none / border / box.
  const wrapperClass =
    config.style === "border"
      ? "border rounded-lg p-4"
      : config.style === "box"
        ? "bg-muted/30 rounded-lg p-4"
        : "";

  const hasHeader = Boolean(config.title || config.description);

  return (
    <div className={wrapperClass}>
      {hasHeader && (
        <FlowComponentHeader
          title={config.title}
          description={config.description}
          className="mb-4"
        />
      )}
      {/* QL-776: embed HTML is never inserted into the app document — it always renders in the
          sandboxed frame. Third-party pages use the `iframe` component. */}
      <EmbedFrame html={config.html} />
    </div>
  );
}
